import { Icons } from '@/assets/icons/icons';
import { cn } from '@/lib/utils';

import { getWebDownloadInfo, startWebDownload } from './web-platform';

type Variant = 'solid' | 'paper';
type Size = 'sm' | 'md' | 'lg';

const sizeClasses: Record<Size, string> = {
  sm: 'h-8 gap-1.5 px-3 text-[13px] [&_svg]:size-3.5',
  md: 'h-9 gap-2 px-4 text-sm [&_svg]:size-4',
  lg: 'h-11 gap-2 px-6 text-[15px] [&_svg]:size-4',
};

const variantClasses: Record<Variant, string> = {
  solid: 'bg-accent text-accent-foreground hover:bg-accent-hover',
  paper: 'bg-[#FFFAEB] text-[#1B1C15] hover:bg-white',
};

/** Plain download CTA — kicks off a normal browser download on click. */
export const DownloadButton = ({
  variant = 'solid',
  size = 'md',
  className,
}: {
  variant?: Variant;
  size?: Size;
  className?: string;
}) => {
  const { label } = getWebDownloadInfo();

  return (
    <button
      type="button"
      onClick={startWebDownload}
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-lg font-medium whitespace-nowrap',
        'shadow-[0_2px_10px_rgba(27,28,21,0.18)] transition-colors',
        sizeClasses[size],
        variantClasses[variant],
        className
      )}
    >
      <Icons.download />
      {label}
    </button>
  );
};
